import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { applyUpdate, SW_UPDATE_EVENT } from '../../utils/serviceWorker';

// An installed app keeps running the build it cached, so a deploy is
// invisible until something says so. The service worker downloads the new
// build in the background and this offers the reload that switches to it —
// on the user's beat, so a refresh never lands mid-sync or mid-chat.

const STROKE = 2.75;

function UpdateBanner() {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const onUpdate = (event) => setRegistration(event.detail);
    window.addEventListener(SW_UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(SW_UPDATE_EVENT, onUpdate);
  }, []);

  if (!registration) return null;

  return (
    <div className="pwa-pill" role="status">
      <span>New version available</span>
      <button type="button" className="pwa-pill-btn" onClick={() => applyUpdate(registration)}>
        <RefreshCw size={12} strokeWidth={STROKE} style={{ verticalAlign: '-1px' }} /> Refresh
      </button>
    </div>
  );
}

export default UpdateBanner;
